import { useMemo } from "react";
import { useTeacherStudentReviews } from "./useTeacherStudentReviews.ts";

export function useTeacherStudentReviewHistory(teacherId: string) {
  const { result, loading } = useTeacherStudentReviews(teacherId);

  const studentReviewGroups = useMemo(() => result?.students ?? [], [result]);

  return {
    studentReviewGroups,
    loading: loading && !result,
  };
}
